import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGIN_RESPONSE,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
  CLEAR_LOGIN_ERROR,
} from "./actionTypes";

const initialState = {
  error: "",
  loading: false,
  loginResponse: null,
  user: null,
};

const login = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_USER:
      return {
        ...state,
        loading: true,
        error: "",
      };

    case LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        user: action.payload,
        loginResponse: null,
        error: "",
      };

    case LOGIN_RESPONSE:
      return {
        ...state,
        loading: false,
        loginResponse: action.payload,
        error: "",
      };

    case LOGOUT_USER:
      return {
        ...state,
        loading: true,
      };

    case LOGOUT_USER_SUCCESS:
      return {
        ...state,
        user: null,
        loading: false,
      };

    case API_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
        loginResponse: null,
      };

    case CLEAR_LOGIN_ERROR:
      return {
        ...state,
        error: "",
        loginResponse: null,
      };

    default:
      return state;
  }
};

export default login;